import { Colors } from '../../consts/Colors';
import Obstacle from '../Obstacle';

export default class Poisson9 extends Obstacle {
    constructor(scene, x, y, params = { showHitbox: false }) {
        super(scene, x, y, params);

        this.scene = scene;
        this.type = 'poisson9';
        this.speed = 250;
        this.setPosition(x, y);
        scene.add.existing(this);
    }

    addBody(params) {
        this.texture = this.scene.add.sprite(0, 0, 'poisson9').setOrigin(0.5);
        this.texture.anims.play('poissonAnim9');
        this.add(this.texture);
    }
}
